'use client';

import ChartJS from 'chart.js/auto';
import { type ChartConfiguration } from 'chart.js/auto';
import { useRef } from 'react';

import { useMount } from '@/shared/hooks';

type ChartProps = ChartConfiguration;

export function Chart({ ...props }: ChartProps) {
	const ref = useRef<HTMLCanvasElement>(null);
	const chart = useRef<ChartJS>(null);

	useMount(() => {
		if (!chart.current && ref.current) {
			chart.current = new ChartJS(ref.current, props);
		}
	});

	return <canvas ref={ref} />;
}
